import React, { useState } from "react";
import { Link } from "react-router-dom";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import HeroImg from "../../assets/landing/image2.webp";
import HeroImg_LQ from "../../assets/landing/image2_lq.webp";
import 'react-lazy-load-image-component/src/effects/blur.css';

// services
import ServicesSection from "../../components/Common/ServicesSection";
import FeatureCardImg from "../../assets/landing/feature_card__tasker_img.png";
import { taskerFeatures } from "../../constants/StringLitterels";

// how it works
import HowItWorksSection from "../../components/Common/HowItWorksSection";
import { taskerWorkSteps } from "../../constants/StringLitterels";
import WorkStepImg from "../../assets/landing/tasker-howItWork.jpg";

import TestimonialSection from "../../components/Common/TestimonialSection";
import { taskersTestimonials } from "../../Data/Data";

import QuestionImg from "../../assets/landing/question-section-gif.gif";
import FAQSection from "../../components/Tasker/FAQSection";
import { twMerge } from "tailwind-merge";
import { taskerQuestions } from "../../constants/commonConstants";

const TaskerHome = () => {

  const [loadedHero, setLoadedHero] = useState(false);

  return (
    <div className=" w-full min-w-[320px] mt-12  mb-[88px]">
      {/* Hero Section */}
      <div className="w-full px-[20px] md:px-[40px] lg:px-[100px]">
        <div className="h-[520px] relative overflow-hidden md:rounded-[40px] rounded-[20px]">
          <div className={twMerge("flex w-full h-[100%] rounded-[20px]", loadedHero ? "bg-transparent" : "bg-gray-600 animate-pulse")}>
            <LazyLoadImage
              src={HeroImg}
              placeholderSrc={HeroImg_LQ}
              alt="Skilled Professional"
              className="w-full h-full object-cover"
              effect="blur"
              onLoad={() => {
                setLoadedHero(true);
              }}
            />
          </div>      
          <div className="absolute inset-0 bg-[#212020] opacity-60"></div>
          <div className="absolute md:ml-6 lg:ml-12 inset-0 flex flex-col justify-center w-full text-center sm:text-justify md:w-[488px] md:max-w-[488px] text-white gap-10 px-4 md:px-0">
            <h1 className="text-[32px] sm:text-[42px] leading-[47.5px] tracking-[0.1%] text-primary font-bold font-nonito_sans">
              Unlock Your Potential as a Skilled Professional
            </h1>
            <p className="text-[15px] sm:text-[17px] font-inter font-normal leading-[24px] md:w-[440px]">
              Join a community of experts and connect with clients looking for
              your unique skills. Secure payments, flexible work hours, and a
              user-friendly dashboard make it easier than ever to grow your
              career.
            </p>
            <Link
              to="/service-pro/explore-jobs"
              className="bg-primary flex items-center justify-center text-dark font-inter font-semibold text-base w-full sm:w-[214px] h-[49px] rounded-xl hover:bg-primary/90 transition-colors"
            >
              Find a Job
            </Link>
          </div>
        </div>
      </div>

      {/* Services Section */}
      <div className=" mt-[88px]">
        <ServicesSection
          buttonText="Find a Job"
          description="Find trusted clients, explore a wide range of jobs, and enjoy safe, secure payments—all with verified information to help you choose the best."
          featureCardImg={FeatureCardImg}
          features={taskerFeatures}
          navigationLink={"/service-pro/explore-jobs"}
        />
      </div>

      {/* How It Works Section */}
      <div className="mt-[88px]">
        <HowItWorksSection
          workSteps={taskerWorkSteps}
          rightImage={WorkStepImg}
        />
      </div>

      {/* <div className="">
        <TestimonialSection
          testimonials={taskersTestimonials}
          heading="Exceptional Service Stories"
          color="#FFEB3B"
        />
      </div> */}

      {/* StatisticsSection */}
      {/* <div className="flex flex-col bg-white gap-10 justify-center pb-[88px] lg:mb-[176px] px-4 sm:px-0 sm:flex-row">
        <div className="flex flex-col items-center gap-4 sm:border-r-4 sm:border-[#FBC948] sm:pr-6">
          <h1 className="font-nonito_sans font-bold text-dark text-[48px] md:text-[80px] sm:leading-[72px]">
            700+
          </h1>
          <span className="font-inter text-[20px] md:text-[30px]  leading-[22.4px] text-[#6A737D]">
            Completed Jobs
          </span>
        </div>
        <div className="flex flex-col items-center gap-4 sm:border-r-4 sm:border-[#FBC948] sm:pr-6">
          <h1 className="font-nonito_sans font-bold text-dark text-[48px] md:text-[80px] sm:leading-[72px]">
            15k+
          </h1>
          <span className="font-inter text-[20px] md:text-[30px] leading-[22.4px] text-[#6A737D]">
            Clients
          </span>
        </div>
        <div className="flex flex-col items-center gap-4">
          <h1 className="font-nonito_sans font-bold text-dark text-[48px] md:text-[80px] sm:leading-[72px]">
            98%
          </h1>
          <span className="font-inter text-[20px] md:text-[30px] leading-[22.4px] text-[#6A737D]">
            Success Rate
          </span>
        </div>
      </div> */}

      {/* FAQ Section  */}
      <div className=" flex flex-col gap-12 px-[20px] md:px-[40px] lg:px-[100px]">
        <div className="h-[520px] relative overflow-hidden md:rounded-[40px] rounded-[20px]">
          <img
            src={QuestionImg}
            alt="Skilled Professional"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-[#212020] opacity-60"></div>
          <div className="absolute md:ml-6 lg:ml-12 inset-0 flex flex-col justify-center w-full text-center sm:text-justify md:w-[488px] md:max-w-[488px] text-white gap-10 px-4 md:px-0">
            <h1 className="text-[32px] sm:text-[42px] leading-[47.5px] tracking-[0.1%] text-primary font-bold font-nonito_sans">
              Are You Ready To Work With Us Now?
            </h1>
            <p className="text-[15px] sm:text-[17px] font-inter font-normal leading-[24px] md:w-[440px]">
              Join a community of experts and connect with clients looking for
              your unique skills. Secure payments, flexible work hours, and a
              user-friendly dashboard make it easier than ever to grow your
              career.
            </p>
            <Link
              to="/service-pro/explore-jobs"
              className="bg-primary flex items-center justify-center text-dark font-inter font-semibold text-base w-full sm:w-[214px] h-[49px] rounded-xl hover:bg-primary/90 transition-colors"
            >
              Find a Job
            </Link>
          </div>
        </div>

        <div>
          <FAQSection questions={taskerQuestions}/>
        </div>
      </div>
    </div>
  );
};

export default TaskerHome;
